import { Component, Input } from '@angular/core';
import { ColumnSettings } from '../../common/models';

@Component({
    selector: 'number-viewer',
    templateUrl: './number-viewer.component.html',
    styleUrls: ['./number-viewer.component.scss'],
})
export class NumberViewerComponent {
  @Input('record') record: any;
  @Input('column') column!: ColumnSettings;

  constructor() { }
}
